// src/constants/errorMessages.js
export const CASE_ERRORS = {
    FETCH_ERROR: 'خطأ في جلب بيانات القضايا',
    FETCH_CASE_ERROR: 'خطأ في جلب بيانات القضية',
    // Add other error messages as needed
};